<section>
  <div class="flex items-center justify-between px-4 pt-4" #headerContainer>
    <div class="flex items-center">
      <mat-icon>directions_run</mat-icon>
      <h1>Inventory of Services ({{ activeServices.length || 0 }})</h1>
    </div>
    @if (services.length > 0) {
      <div class="flex items-center gap-2">
        <app-csv-download
          [iconOnly]="false"
          [csvData]="formattedCSVData"
          [fileName]="'ServicesInventory.csv'"
        ></app-csv-download>
      </div>
    }
  </div>
  @if (services.length > 0) {
    <div class="flex items-center justify-between gap-4 px-4">
      <div class="search-wrapper">
        <mat-form-field>
          <div class="custom-icon search">search icon</div>
          <input
            matInput
            [formControl]="searchTermControl"
            placeholder="Search (Ex: SD-WAN)"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <a class="btn-secondary" (click)="toggleShowDiv('filter-wrapper')">
        <div class="custom-icon filter">filter icon</div>
        Filter
        @if (totalSelectedFilters > 0) {
          <div class="total-filter-selected">
            {{ totalSelectedFilters }}
          </div>
        }
      </a>
    </div>
  }

  <div class="filter-wrapper" [@slideInOut]="animationState">
    <div class="filter-dropdowns">
      <mat-form-field>
        <mat-select
          placeholder="Locations"
          [formControl]="locationsFilterFormControl"
          [(value)]="selectedLocationFilters"
          multiple
          class="dropdown-locations"
        >
          @for (location of locationsFilterOptions; track location) {
            <mat-option [value]="location">{{ location }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select
          placeholder="Service"
          [formControl]="serviceFilterFormControl"
          [(value)]="selectedServiceFilters"
          multiple
          class="dropdown-services"
        >
          @for (type of serviceFilterOptions; track type) {
            <mat-option [value]="type">{{ type }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select
          placeholder="Status"
          [formControl]="statusFilterFormControl"
          [(value)]="selectedStatusFilters"
          multiple
          class="dropdown-status"
        >
          @for (status of statusFilterOptions; track status) {
            <mat-option [value]="status">{{
              status === 'New' ? 'Pending' : status
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="selected-options">
      <ul>
        @for (location of locationsFilterFormControl.value; track location) {
          <li class="selected-location">
            <a (click)="removeFilterSelection('Z_Location__r.Name', location)">
              {{ location }}
              <div class="custom-icon close_sm_white">close icon</div>
            </a>
          </li>
        }
        @for (service of serviceFilterFormControl.value; track service) {
          <li class="selected-service">
            <a (click)="removeFilterSelection('RecordType.Name', service)">
              {{ service }}
              <div class="custom-icon close_sm_white">close icon</div>
            </a>
          </li>
        }
        @for (status of statusFilterFormControl.value; track status) {
          <li class="selected-status">
            <a (click)="removeFilterSelection('Status__c', status)">
              {{ status === 'New' ? 'Pending' : status }}
              <div class="custom-icon close_sm_white">close icon</div>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>

  @if (services.length > 0) {
    <div class="group-wrapper font-montserrat">
      <div class="group-label">
        <div class="custom-icon sort_arrows">sort icon</div>
        <span>Group by:</span>
      </div>

      @if (groupedServices) {
        <div class="group-options">
          <button
            (click)="onClickGroupBy('Location')"
            [disabled]="
              hasObjectLength(groupedServices, 1) &&
              groupByFormControl.value === 'Z_Location__r.Name'
            "
            [ngClass]="{
              'active-link': groupByFormControl.value === 'Z_Location__r.Name',
            }"
          >
            <span>
              Location
              <div
                class="custom-icon"
                [ngClass]="{
                  sort_asc: isAscFormControl.value,
                  sort_desc: !isAscFormControl.value,
                }"
              >
                sort icon
              </div>
            </span>
          </button>
          <button
            (click)="onClickGroupBy('Service')"
            [disabled]="
              hasObjectLength(groupedServices, 1) &&
              groupByFormControl.value === 'RecordType.Name'
            "
            [ngClass]="{
              'active-link': groupByFormControl.value === 'RecordType.Name',
            }"
          >
            <span>
              Service
              <div
                class="custom-icon"
                [ngClass]="{
                  sort_asc: isAscFormControl.value,
                  sort_desc: !isAscFormControl.value,
                }"
              >
                sort icon
              </div>
            </span>
          </button>
          <button
            (click)="onClickGroupBy('Status')"
            [disabled]="
              hasObjectLength(groupedServices, 1) &&
              groupByFormControl.value === 'Status__c'
            "
            [ngClass]="{
              'active-link': groupByFormControl.value === 'Status__c',
            }"
          >
            <span>
              Status
              <div
                class="custom-icon"
                [ngClass]="{
                  sort_asc: isAscFormControl.value,
                  sort_desc: !isAscFormControl.value,
                }"
              >
                sort icon
              </div>
            </span>
          </button>
        </div>
      }
    </div>
  }

  @if (isLoading || isServicesInProgress) {
    <div class="loading-indicator">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else if (groupedServices && hasObjectLength(groupedServices, 0)) {
    @if (services.length > 0) {
      <div class="inventory-empty">
        There are no services based on your search.
      </div>
    } @else {
      <div class="inventory-empty">There are currently no services yet.</div>
    }
  } @else {
    <div class="inventory-viewport">
      @if (groupedServices) {
        <mat-accordion>
          @for (
            inventory of groupedServices
              | paginate: { itemsPerPage: 10, currentPage: page };
            track inventory.groupTitle;
            let isFirst = $first
          ) {
            <mat-expansion-panel [expanded]="isFirst">
              <mat-expansion-panel-header
                (click)="onHeaderClick(inventory.services[0])"
              >
                <mat-panel-title>
                  <div
                    class="custom-icon"
                    [ngClass]="{
                      location_dark:
                        groupByFormControl.value === 'Z_Location__r.Name',
                      circuit_dark:
                        groupByFormControl.value === 'RecordType.Name',
                      services_icon: groupByFormControl.value === 'Status__c',
                    }"
                  >
                    group icon
                  </div>

                  <div class="group-title">
                    @if (groupByFormControl.value === 'Z_Location__r.Name') {
                      <span>
                        {{ inventory.services[0].CustomerLocationAlias }}
                      </span>
                    }
                    {{ inventory.groupTitle | uppercase }}
                  </div>
                </mat-panel-title>

                <mat-panel-description>
                  <span class="total-mrc font-lato">
                    Total Number Services:
                    {{ inventory.services.length }} &nbsp;&nbsp;&nbsp;&nbsp;
                    Total: {{ inventory.totalMrc | currency }}</span
                  >
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="row-scroll">
                @for (
                  service of inventory.services;
                  track service.Name;
                  let i = $index
                ) {
                  <div
                    [class.selected]="service === selectedService"
                    tabindex="0"
                    class="inventory-row"
                    (keyup.enter)="onSelectService(service)"
                  >
                    <div class="inventory-inner">
                      <div class="inventory-description">
                        <div class="description">
                          <div class="inventory-top-detail">
                            @if (
                              groupByFormControl.value === 'Z_Location__r.Name'
                            ) {
                              <div class="custom-icon circuit_dark">
                                circuit icon
                              </div>
                              <div class="service-wrapper">
                                SERVICE: {{ service.Name | uppercase }} -
                                {{ service.RecordType.Name | uppercase }}
                                @if (service.Bandwidth_Downstream__c) {
                                  - {{ service.Bandwidth_Downstream__c }}
                                }
                                @if (service.Asymmetrical_Bandwidth__c) {
                                  / {{ service.Bandwidth_Upstream__c }}
                                }
                                @if (service.Vendor__r) {
                                  -
                                  {{
                                    service.Vendor__r.Display_Alias__c
                                      ? service.Vendor__r.Display_Alias__c
                                      : service.Vendor__r.Name
                                  }}
                                }
                              </div>
                            }
                            @if (
                              groupByFormControl.value !== 'Z_Location__r.Name'
                            ) {
                              <div class="custom-icon location_dark">
                                location icon
                              </div>
                              <div class="service-wrapper">
                                {{ service.Z_Location__r.Name }}
                              </div>
                            }
                          </div>
                          @if (
                            groupByFormControl.value !== 'Z_Location__r.Name'
                          ) {
                            <div class="inventory-bottom-detail">
                              <div class="inventory-service">
                                <div class="custom-icon circuit_dark">
                                  circuit icon
                                </div>

                                <div class="service-wrapper">
                                  SERVICE: {{ service.Name | uppercase }}
                                  @if (
                                    groupByFormControl.value !==
                                    'RecordType.Name'
                                  ) {
                                    - {{ service.RecordType.Name | uppercase }}
                                  }
                                  @if (service.Bandwidth_Downstream__c) {
                                    - {{ service.Bandwidth_Downstream__c }}
                                  }
                                  @if (service.Asymmetrical_Bandwidth__c) {
                                    / {{ service.Bandwidth_Upstream__c }}
                                  }
                                  @if (service.Vendor__r) {
                                    -
                                    {{
                                      service.Vendor__r.Display_Alias__c
                                        ? service.Vendor__r.Display_Alias__c
                                        : service.Vendor__r.Name
                                    }}
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      <div class="status-mrc">
                        <div class="status">
                          STATUS:
                          <span
                            class="label"
                            [ngClass]="{
                              open: service.Status__c === 'In Service',
                              pending:
                                service.Status__c === 'New' ||
                                service.Status__c === 'Pending',
                              closed:
                                service.Status__c === 'Canceled' ||
                                service.Status__c === 'Disconnected',
                            }"
                          >
                            {{
                              service.Status__c === 'New'
                                ? 'Pending'
                                : service.Status__c
                            }}
                          </span>

                          <div class="view-more">
                            <div
                              class="custom-icon arrow_progress_inactive"
                            ></div>
                            <div class="custom-icon arrow_progress"></div>
                          </div>
                        </div>

                        <div class="monthly-charges">
                          Monthly Charges:
                          <span>{{
                            service.MRR__c
                              ? (service.MRR__c | currency)
                              : (0 | currency)
                          }}</span>
                        </div>
                      </div>
                      <a
                        routerLink="{{ service.Id }}"
                        tabindex="-1"
                        class="inventory-link-outer"
                        ><div class="inventory-link mobile">mobile</div></a
                      >
                      <a (click)="onSelectService(service)" tabindex="-1"
                        ><div class="inventory-link desktop">desktop</div></a
                      >
                    </div>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <div class="flex justify-center py-6">
          <pagination-controls
            (pageChange)="page = $event"
            [autoHide]="true"
          ></pagination-controls>
        </div>
      }
    </div>
  }

  <app-footer class="flex md:hidden"></app-footer>
</section>
